<template>
  <div :class="chunjingmoshi?'head_bg_color':''" id="headWrap">
    <div class="logo">
      <img :src="logo" style="width: auto;height: 30px" alt @click="refresh" />
      <div class="change_cond">
        <ul>
          <li
                  v-for="(item, index) in rizhouyueArr"
                  :key="index"
                  :class="{active: rizhouyueInd == index}"
                  @click="changeData(index)"
          >
            {{item}}
          </li>
        </ul>
      </div>
      <span class="time">
        {{time.substring(0, 10)}}
      </span>
    </div>
    <div class="title">
      <div class="tit_box dp_fs_color">
        <span>
<!--          <img :src="border1" alt class="b1" />-->
          <!--          <img :src="border2" alt class="b2" />-->
              {{systemName}}
          <!--          <img :src="guang" alt class="head_guang1" />-->
          <!--          <img :src="guang" alt class="head_guang2" />-->
        </span>
      </div>
      <!-- <div class="tit_box dp_fs_color" v-if="marqueeList.length>0" @click="marqueeclick">
         <marquee scrollamount="1" direction=up class="head_bg_title">
           <p v-for="(item ,index) in marqueeList" :key="index">{{item.title | ellipsis}}</p>
         </marquee>
       </div>-->
    </div>
    <div class="userWrap">
      <ul>
        <li class="time" style="font-size: 20px">
          {{time.substring(10, 20)}}
        </li>
        <li class="ditu" @click="headclick" title="跳转驾驶舱">
          <img :src="cockpit" alt />
        </li>
        <li class="jcxx" @click="baseInfoLayer" title="基础信息">
          <img :src="fengxian" alt />
        </li>
        <!--<li class="ditu" @click="showFengxian" title="安全指数">-->
        <!--<img :src="fengxian" alt />-->
        <!--</li>-->
        <li class="ditu" @click="zsptFn" title="跳转管理平台">
          <img :src="zspt" alt />
        </li>
        <li class="ditu" @click="dituFn" title="纯净模式">
          <img :src="ditu" alt />
        </li>
        <li class="dingwei" @click="dingweiFn" title="地图定位">
          <img :src="dingwei" alt />
        </li>
        <li class="ditu" @click="jqgzFn" title="警情跟踪">
          <img :src="jqgz" alt />
        </li>
        <li style="padding: 0 20px;" class="dp_fs_color">
          |
        </li>
        <li class="shengyin" @click="shengyinFn" title="消音/解除消音">
          <img :src="shengyin" v-if="!shengxiao" alt :class="{ shengyin_option :!shengyin_status}" />
          <img :src="xiaoyin" v-if="shengxiao" alt :class="{ shengyin_option :!shengyin_status}" />
        </li>
        <li class="full" @click="fullFn" title="全屏/退出全屏">
          <img :src="quanping" alt />
        </li>
        <!--        <li class="theme" @click="showTheme" title="更换皮肤">-->
        <!--          <img :src="yanse" alt="">-->
        <!--          <ul class="select head_bg_color dp_fs_color" v-if="themeStatus">-->
        <!--            <li class="dp_fs_color" :class="{bd_color: index == 0}" v-for="(item, index) in themeArr" :key="index" @click="changeTheme(index)">-->
        <!--                    <span class="color">-->

        <!--                    </span>-->
        <!--              <span class="name">-->
        <!--                        {{item}}-->
        <!--                    </span>-->
        <!--            </li>-->
        <!--          </ul>-->
        <!--        </li>-->
        <li class="user" title="个人中心">
          <img :src="person" alt class="user-logo" @click="sectionFn" />
          <div class="head_bg_color user_box" v-if="section_status">
            <img :src="userImg" alt @click="getUser($event)" />
            <img :src="quit" alt @click="quitFn($event)" />
          </div>
          <div class="userDetail dp_fs_color" v-if="userShow">
            <p class="userDetailTitle">
              <span>登录信息</span>
              <img :src="close" alt @click="closeUserDetail($event)" />
            </p>
            <p class="loginName">
              <span :title=userData.loginName>登录名：{{userData.loginName}}</span>
            </p>
            <p class="userName">
              <span :title=userData.userName>用户名称：{{userData.userName}}</span>
            </p>
            <p class="userPhone">
              <span :title=userData.phone>联系方式：{{userData.phone}}</span>
            </p>
            <p class="company">
              <span style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;display: block;" :title=userData.orgName>所属单位：{{userData.orgName}}</span>
            </p>
          </div>
        </li>
      </ul>
    </div>
    <div class="mask" v-if="isShow">
      <div class="maskCon">
        <p>提示</p>
        <p>{{easyCon}}</p>
        <b @click="quitFn()">确定</b>
      </div>
    </div>
  </div>
</template>
<script>
    // 这两张还没有修改主题的图片
    import fengxian from '@/assets/img/fengxian.png';
    import shipin from '@/assets/img/shipin.png';
    import jqgz from "@/assets/img/jqgz.png";
    import zspt from "@/assets/img/zspt.png";
    import cockpit from "@/assets/images/cockpit/jiashicang.png";


    import {themeArr} from '@/assets/js/theme.js'
    import closeImg from "@/assets/img/close.png";

    import border1 from "@/assets/img/head-text-b1.png";
    import border2 from "@/assets/img/head-text-b2.png";
    import headGuang from "@/assets/img/head-guang.png";

    import userImg from "@/assets/img/user1.png";
    import quit from "@/assets/img/quit.png";

    import vueMarquee from 'vue-marquee';
    import {newUrl} from '@/assets/js/newurl.js'
    import axiosT from 'axios';
    export default {
        name: "",
        filters: {
            ellipsis (value) {
                if (!value) return ''
                if (value.length > 26) {
                    return value.slice(0,26) + '...'
                }
                return value
            }
        },
        data: () => ({
            marqueeList:[],//新闻列表
            isShow:false,
            easyCon:'',
            cockpit:cockpit,
            fengxian: fengxian,
            shipin: shipin,
            userImg: userImg,
            quit: quit,
            /*   logo: themeArr[0].logo,*/
            yanse: themeArr[0].yanse,
            logo:'',
            systemName:'',
            jqgz: jqgz,
            zspt: zspt,
            ditu: themeArr[0].ditu,
            yypt: themeArr[0].yypt,
            dingwei: themeArr[0].dingwei,
            shengyin: themeArr[0].shengyin,
            xiaoyin: themeArr[0].xiaoyin,
            shengxiao:false,
            quanping: themeArr[0].quanping,  //全屏按钮
            person: themeArr[0].person,      //个人中心
            time: "2018-8-26 11:27",
            userShow: false,
            setFull: false,
            close: closeImg,
            hasDetailData: false,
            border1: border1,
            border2: border2,
            guang: headGuang,
            chunjingmoshi: false,
            rizhouyueArr: ["今日", "本周", "本月"],
            rizhouyueInd: 0,
            section_status: false,
            shengyin_status: true,
            getDate: "/mcbw/users/logout",
            userData: "",

            themeStatus: false,
            themeArr:[
                '湖蓝色','群青色'
            ]
        }),
        props:[
            'chunjingStatus'
        ],
        watch:{
            chunjingStatus(res){
                if(this.chunjingmoshi != res){ //如果其他地方改变纯净模式，这里状态要保持一致
                    this.chunjingmoshi = res;
                }
            }
        },
        components: {
            vueMarquee
        },
        created() {
            this.getTime();
        },
        computed: {

        },
        mounted() {
            this.userData = JSON.parse(window.localStorage.getItem("loginData"));
            this.logo=this.userData.bsLogoPath||themeArr[0].logo;
            this.systemName=this.userData.systemName||'智慧消防物联网值守服务平台';

            let userPath = 'runWatchScreen_' + JSON.parse(window.localStorage.getItem("loginData")).loginName;  //通道号APPcode+手机号
            let that = this;
            //账号多人登陆通知
            // this.$mqtt.subscribe(userPath, (message) => {
            //   console.log(message)
            //   let data = message.toString();
            //   console.log('推送接收多人登录',JSON.parse(data))
            //   if (JSON.parse(data).token == localStorage.getItem('randVal_token')) {
            //     that.isShow = true;
            //     that.easyCon = JSON.parse(data).content;
            //   }
            // })
            // this.newsList();
        },
        methods: {
            headclick(){
                this.$emit('headclick');
            },
            newsList(){
                var that=this;
                this.$axios.get(newUrl+'/bbs/news', {
                    params: {
                        type:1,
                        pageSize:10,
                        pageNum:1,
                        areaId:this.userData.areaId
                    }
                }).then(function (response) {
                    if(response.data.success){
                        that.marqueeList=response.data.data
                    }
                }).catch(function (error) {
                    alert(error);
                });

            },
            marqueeclick(){
                let routeData = this.$router.resolve({
                    name: "news-info"
                });
                window.open(routeData.href, '_blank');
            },
            showVideo() {
                this.$store.commit('baseInfoLayer', {
                    listStatus: false,
                    detailStatus: false,
                });
                this.$emit("shipinStatus", new Date());
            },
            baseInfoLayer(){ //左侧单位列表弹窗显示
                this.$store.commit('baseInfoLayer', {
                    listStatus: true,
                });
            },
            showFengxian(){  //显示弹窗
                this.$emit('listLayer', new Date());
            },
            showTheme(){
                this.themeStatus = !this.themeStatus;
            },
            changeTheme(index){
                switch (index) {
                    case 0:  //湖蓝色
                        document.querySelector('html').setAttribute('theme', 'theme2');
                        this.logo = themeArr[1].logo;
                        this.yanse = themeArr[1].yanse;
                        this.ditu = themeArr[1].ditu;
                        this.yypt = themeArr[1].yypt;
                        this.dingwei = themeArr[1].dingwei;
                        // this.shengyin = themeArr[1].shengyin;
                        this.xiaoyin = themeArr[1].xiaoyin;
                        this.quanping = themeArr[1].quanping;
                        this.person = themeArr[1].person;
                        break;
                    case 1:  //群青色
                        document.querySelector('html').setAttribute('theme', 'theme1');
                        this.logo = themeArr[0].logo;
                        this.yanse = themeArr[0].yanse;
                        this.yypt = themeArr[0].yypt;
                        this.dingwei = themeArr[0].dingwei;
                        // this.shengyin = themeArr[0].shengyin;
                        this.xiaoyin = themeArr[0].xiaoyin;
                        this.quanping = themeArr[0].quanping;
                        this.person = themeArr[0].person;
                        break;
                }

                this.$emit('themeStyle', index);

            },
            changeData(index) {
                this.rizhouyueInd = index;
                this.$emit("changeData", index);
                this.$store.commit('setHeadDate', index);
            },
            refresh() {
                //刷新当前页面
                location.reload();
            },
            getTime() {
                var that = this;
                setInterval(function() {
                    var date = new Date();
                    var year = date.getFullYear(); //获取当前年份
                    var mon = date.getMonth() + 1; //获取当前月份
                    var da = date.getDate(); //获取当前日
                    var h = date.getHours(); //获取小时
                    var m = date.getMinutes(); //获取分钟
                    var s = date.getSeconds(); //获取当前秒数
                    if (da <= 9) {
                        da = "0" + da;
                    }
                    if (h <= 9) {
                        h = "0" + h;
                    }
                    if (mon <= 9) {
                        mon = "0" + mon;
                    }
                    if (m <= 9) {
                        m = "0" + m;
                    }
                    if (s <= 9) {
                        s = "0" + s;
                    }
                    that.time = year + "." + mon + "." + da + " " + h + ":" + m + ":" + s;
                }, 1000);
            },
            dituFn() {
                this.chunjingmoshi = !this.chunjingmoshi;
                this.$emit("chunjing", this.chunjingmoshi);
            },
            zsptFn() { //跳转值守平台
                const loginname = JSON.parse(window.localStorage.getItem("loginData")).loginName;
                const pwdHash = window.localStorage.getItem("hashValue");
                let skipWeb;
                if(JSON.parse(window.localStorage.getItem("loginData")).skipWeb){
                    skipWeb = JSON.parse(window.localStorage.getItem("loginData")).skipWeb
                }else{
                    skipWeb = 'http://zsv.ayy123.com/#/login'
                }
                window.open(`${skipWeb}?user_phone=${loginname}&user_token=${pwdHash}`
                );
            },
            jqgzFn() {
                let loginData = JSON.parse(window.localStorage.getItem("loginData"));
                const loginname = loginData.loginName;
                var pwdHash = window.localStorage.getItem("hashValue");
                window.open(
                    `http://alarm.ayy123.com/police-track?loginName:${loginname}&appcode:runWatchScreen&pwdHash:${pwdHash}&token:${window.localStorage.getItem('randVal_token')}`
                );
            },
            dingweiFn() {
                let data = new Date();
                this.$emit("dingwei", data);
            },
            shengyinFn() {
                // this.shengyin_status = !this.shengyin_status;
                this.shengxiao = !this.shengxiao;
                let data = {
                    date: new Date(),
                    status: this.shengyin_status
                };
                this.$emit("shengyinStatus", data);
            },
            fullFn() {
                if (this.setFull) {
                    //如果已经全屏了，取消全屏
                    var de = document;
                    if (de.exitFullscreen) {
                        de.exitFullscreen();
                    } else if (de.mozCancelFullScreen) {
                        de.mozCancelFullScreen();
                    } else if (de.webkitCancelFullScreen) {
                        de.webkitCancelFullScreen();
                    }
                } else {
                    //如果没有全屏，则进行全屏
                    var de = document.documentElement;
                    if (de.requestFullscreen) {
                        de.requestFullscreen();
                    } else if (de.mozRequestFullScreen) {
                        de.mozRequestFullScreen();
                    } else if (de.webkitRequestFullScreen) {
                        de.webkitRequestFullScreen();
                    }
                }
                this.setFull = !this.setFull;
            },
            sectionFn() {
                this.section_status = !this.section_status;
            },
            getUser(e) {
                e.stopPropagation();
                this.userShow = true;
            },
            quitFn() {
                if (window.localStorage.getItem("loginData") == null) {
                    this.$router.replace({ name: "login" });
                    window.localStorage.removeItem("loginData");
                    window.localStorage.removeItem("hashValue");
                    return false;
                }
                var loginname = JSON.parse(window.localStorage.getItem("loginData"))
                    .loginName;
                var data = {
                    type: 'post',
                    url: this.getDate,
                    obj: {}
                };
                this.$Axios(data).then(res => {
                    console.log(res);
                    if (res.data.success) {
                        this.$store.commit('baseInfoLayer', {
                            listStatus: false,
                            detailStatus: false,
                            baseInfoId: '',
                            baseInfoItem: {}
                        });
                        this.$store.commit('showLayer', {
                            status: false,
                            type: '',
                        });
                        this.$mqtt.end();
                        console.log('退出成功');
                        //退出成功跳转到登录页
                        this.$router.replace({ name: "login" });
                        window.localStorage.removeItem("loginData");
                        window.localStorage.removeItem("hashValue");
                        window.localStorage.removeItem("randVal_token");
                        //退出登录后，清除本地报警信息数据
                    }
                })
                    .catch(res => {
                        console.log(res);
                    });
            },
            closeUserDetail(e) {
                e.stopPropagation();
                this.userShow = false;
            },
        }
    };
</script>
<style lang="scss" scoped>
  #headWrap {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    height: 87px;
    line-height: 87px;
    text-align: center;
    background-image: url("../../static/head-bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position:center;
    position: relative;
    z-index: 1;
    .logo {
      position: absolute;
      z-index: 2;
      height: 100%;
      top: 0;
      left: 0;
      vertical-align: middle;
      margin-left: 15px;
      font-size: 0;
      cursor: pointer;
      line-height: 67px;
      img {
        display: inline-block;
        vertical-align: middle;
      }
      .change_cond {
        color: white;
        margin-left: 40px;
        display: inline-block;
        vertical-align: middle;
        overflow: hidden;
        font-size: 16px;
        ul {
          margin-left: 15px;
          float: left;
          overflow: hidden;
          li {
            float: left;
            padding: 0 12px;
            position: relative;
            cursor: pointer;
            i {
              position: absolute;
              right: -1px;
              top: 35.5px;
              width: 2px;
              height: 16px;
            }
          }
          .active {
            background-image: url("../assets/img/activeBg.png");
            background-repeat: no-repeat;
            background-size: 100% 38%;
            background-position:center;
          }
        }
      }
      .time {
        margin-left: 5px;
        display: inline-block;
        width: 150px;
        text-align: right;
        font-size: 20px;
        vertical-align: top;
        color: white;
      }
    }
    .title {
      position: absolute;
      width: 100%;
      height: 87px;
      text-align: center;
      z-index: 1;
      .tit_box {
        display: inline-block;
        // color: #00eff3;
        span {
          height: 66px;
          box-sizing: border-box;
          display: inline-block;
          font-size: 37px;
          line-height: 4px;
          padding: 39px 24px;
          background-image:-webkit-linear-gradient(bottom,#00bcff,white);
          //text-shadow: 0px 0px 5px white;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          //border: 3px solid #104961;
          //border-radius: 15px 0 15px 0;
          position: relative;
          font-family: PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          .b1 {
            position: absolute;
            left: -3px;
            top: -3px;
          }
          .b2 {
            position: absolute;
            right: -3px;
            bottom: -3px;
          }
          .head_guang1 {
            position: absolute;
            width: 200px;
            top: -50px;
            right: -15px;
            //animation: move2 2s linear infinite alternate;
          }
          .head_guang2 {
            position: absolute;
            width: 200px;
            bottom: -50px;
            left: -15px;
            //animation: move1 2s linear infinite alternate;
          }

          //@-webkit-keyframes move1 {
          //  0% {
          //    left: -50px;
          //    opacity: 0;
          //  }
          //  50% {
          //    opacity: 1;
          //  }
          //  100% {
          //    left: calc(100% - 150px);
          //    opacity: 0;
          //  }
          //}
          //@-webkit-keyframes move2 {
          //  0% {
          //    left: calc(100% - 155px);
          //    opacity: 0;
          //  }
          //  50% {
          //    opacity: 1;
          //  }
          //  100% {
          //    left: -50px;
          //    opacity: 0;
          //  }
          //}
        }
      }
    }
    .userWrap {
      z-index: 2;
      height: 100%;
      top: 0;
      right: 0;
      position: absolute;
      margin-right: 15px;
      ul {
        // overflow: hidden;
        li {
          color: #fff;
          font-size: 22px;
          float: left;
          height: 100%;
          padding: 0 10px;
          cursor: pointer;
          line-height: 67px;
          img {
            display: inline-block;
          }
        }
        /*li:first-child {*/
        /*padding: 0;*/
        /*}*/
        .user {
          cursor: pointer;
          position: relative;
          .user-logo {
            width: 18px;
            height: 18px;
          }
          .user_box {
            position: absolute;
            top: 87px;
            left: 0;
            overflow: hidden;
            background: #1c3545;
            width: 48px;
            img {
              display: block;
              margin: 14px;
              margin-bottom: 28px;
            }
            img:last-child {
              margin-bottom: 14px;
            }
          }
          .userDetail {
            position: fixed;
            height: 338px;
            width: 400px;
            top: 50%;
            left: 50%;
            margin-left: -212.5px;
            margin-top: -140px;
            overflow: hidden;
            background: rgba(28, 53, 69, 1);
            z-index: 1;
            text-align: left;
            text-indent: 32px;
            font-size: 16px;
            padding: 0 0 20px 25px;
            p {
              height: 65px;
              line-height: 65px;
            }
            .userDetailTitle {
              text-indent: 0;
              vertical-align: middle;
              position: relative;
              span {
                font-size: 18px;
              }
              img {
                // float: right;
                display: inline-block;
                position: absolute;
                cursor: pointer;
                width: 14px;
                height: 14px;
                padding: 25.5px;
                top: 0;
                right: 0;
                box-sizing: content-box;
              }
            }
          }
        }
        .full {
          cursor: pointer;
          // width: 15px;
          // height: 15px;
        }
        .shengyin {
          img {
            width: 20px;
            height: 20px;
            &.shengyin_option {
              opacity: 0.5;
            }
          }
        }
        .ditu {
          img {
            width: 20px;
            height: 20px;
          }
        }
        .jcxx {
          img {
            width: 16px;
            height: 20px;
          }
        }
        .dingwei {
          img {
            width: 17px;
            height: 20px;
          }
        }
        .theme{
          width: 45px;
          box-sizing: border-box;
          position: relative;
          .select{
            position: absolute;
            left: -15px;
            top: 87px;
            li{
              width: 75px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              font-size: 0;
              float: initial;
              padding: 0;
              span{
                display: inline-block;
              }
              .color{
                width: 8px;
                height: 8px;
                border: 2px solid #fff;
                vertical-align: middle;
                margin-right: 5px;
              }
              .name{
                font-size: 12px;
                vertical-align: middle;
              }
            }
            li:first-child{
              border-bottom: 1px solid #fff;
              .color{
                background: #a1f2ee;
              }
            }
            li:nth-child(2){
              .color{
                background: #1c92c8;
              }
            }
          }
        }
      }
    }
    .mask{
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.7);
      position: fixed;
      left: 0;
      top: 0;
      z-index: 10;
      .maskCon{
        width: 600px;
        height: 300px;
        margin-left: -300px;
        margin-top: -150px;
        border-radius: 5px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 0 30px;
        background: linear-gradient(rgba(0,2,4,.7),rgba(0,68,93,.7),rgba(0,2,4,.7));
        position: absolute;
        left: 50%;
        top: 50%;
        p{
          color: #00eff3;
        }
        b{
          display: inline-block;
          width: 60px;
          height: 30px;
          line-height: 30px;
          color: #00eff3;
          border-radius: 5px;
          background: rgba(0,2,4,.7) !important;
          cursor: pointer;
        }
      }
    }
  }

  .head_bg_title{
    position: absolute;
    top: 88px;
    left: 40%;
    width: 385px!important;
    height: 39px!important;
    line-height: 39px;
    text-align: center;
    background-color: #172734!important;
    border-radius: 5px;
    border: none;
  }
</style>


// WEBPACK FOOTER //
// src/components/head.vue